import React, { useEffect } from 'react';
import { Flex } from '@chakra-ui/react';
import { Modal, Button } from '@morressier/alembic';
import _ from 'lodash';
import { ISubmissionFile } from '@publishing-engine/domain/models';
import { generateValidationSchema } from 'src/utils/validation';
import { FormProvider, useForm } from 'react-hook-form';
import { ajvResolver } from '@hookform/resolvers/ajv';
import { FormFieldDefinition } from '@publishing-engine/domain/types/article';
import { FormFieldFileList } from '.';
import { SourceFileUpload } from 'src/pages/Organization/public/Journal/SubmissionUpload/components/SourceFileUpload';
import { useCommandResponse } from 'src/contexts/SourceFileCommandResponseContex';
import { checkFileUpload } from 'src/pages/Organization/public/Journal';

export type IFileValue = {
  fileSet: {
    [x: string]: ISubmissionFile[];
  };
};

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (value: IFileValue) => void;
  formField: FormFieldFileList;
  value?: ISubmissionFile[];
  submissionContextId: string;
  referenceName?: string;
  submissionId: string;
}

const SourceFileListUploadModal: React.FC<Props> = props => {
  const {
    isOpen,
    onClose,
    formField,
    onSubmit,
    submissionContextId,
    submissionId
  } = props;

  const defaultValues = _.set(
    {} as IFileValue,
    formField.caseDataFields.main,
    props.value
  );

  const schema = generateValidationSchema({
    [formField.name]: formField
  } as Record<string, FormFieldDefinition>);
  const commandContext = useCommandResponse();
  const commandResponse = commandContext?.commandResponse;
  const methods = useForm({
    defaultValues,
    resolver: ajvResolver(schema)
  });
  useEffect(() => {
    if (commandResponse && commandResponse?.status === 'success') {
      onClose();
    }
  }, [commandResponse]);

  const { getValues } = methods;
  const value = getValues();

  const checkIsFileLoading = () => {
    const values = getValues()
    const status = checkFileUpload(values.fileSet)
    return status
  }

  const isFileUploading = checkIsFileLoading()
  const saveChangesDisable =
    ((value?.fileSet?.SourceFiles?.some(file => file.extension === 'tex') &&
      value?.fileSet?.SourceFiles?.length === 3) || isFileUploading);


  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="755px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(data => {
            onSubmit(data);
            if (formField.name !== 'SourceFiles') {
              onClose();
            }
          })}
        >
          <Flex
            padding={8}
            gap={6}
            bgColor="surfacePrimaryFill"
            flexDirection="column"
            borderRadius="base"
          >
            <Flex maxHeight={700} overflow={'auto'}>
              <SourceFileUpload
                submissionContextId={submissionContextId}
                config={formField}
                submissionId={submissionId}
              />
            </Flex>
            <Flex
              gap={2}
              justifyContent="flex-end"
              alignItems="center"
              alignSelf="stretch"
            >
              <Button
                variant="secondary"
                onClick={onClose}
                borderRadius="small"
                disabled={saveChangesDisable}
                isDisabled={saveChangesDisable}
              >
                Exit Without Saving
              </Button>
              <Button
                variant="primary"
                type="submit"
                borderRadius="small"
                isDisabled={saveChangesDisable}
                disabled={saveChangesDisable}
              >
                Save Changes
              </Button>
            </Flex>
          </Flex>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default SourceFileListUploadModal;
